import React, { useEffect, useRef, useState } from "react";
import styles from "../../styles/profile.module.css";
import { GetTokenApi } from "../../api/api-service";
import { API_Path } from "../../const";
import { toast } from "react-toastify";
import moment from "moment";
import DataTableComponents from "../data_Table/DataTableComponents";
import { exportTableToExcel, exportTableToPDF, maxDateString } from "../common/CommonFun";
import { Table } from "react-bootstrap";
import NoDataFoundImg from "../nodatafound/NoDataFoundImg";
import usePageTitle from "../customHook/usePageTitle";
import PDFIcon from "../../assets/images/file-pdf.svg";
import excelIcon from "../../assets/images/microsoft_excel.svg";
import DatePicker from "react-datepicker";
import Loader from "../loader/Loader";

export default function UserActivity() {
    usePageTitle("User Account", true);
    const [userActivityData, setUserActivityData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState({
        fromDate: "",
        todate: "",
    });
    const [totleRecode, setTotleRecode] = useState(25);
    const [searchQuery, setSearchQuery] = useState("");
    const [btnLoading, setBTNLoading] = useState(false);
    const timeoutRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    useEffect(() => {
        setLoading(true);
        GetUserActivityHistoryData(currentPage, rowsPerPage);
    }, []);

    const handleSearchData = (value) => {
        setLoading(true);
        setSearchQuery(value);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            GetUserActivityHistoryData(currentPage, rowsPerPage, date.fromDate, date.date, value);
        }, 500);
    };

    const handlePageChange = (page) => {
        GetUserActivityHistoryData(page, rowsPerPage, date.fromDate, date.date, searchQuery);
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = async (newRowsPerPage) => {
        if (!userActivityData.length) return;
        GetUserActivityHistoryData(1, newRowsPerPage, date.fromDate, date.date, searchQuery);
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };
    const GetUserActivityHistoryData = (page, rowPerPage, dateFrom, dateTo, searchValue) => {
        const search = searchValue !== "" && searchValue !== undefined ? searchValue : "";
        let queryString = `q={PageNo:${page},PageSize:${rowPerPage},SortColumn:"ent_date",SortDir:"desc",SearchValue:"${search}"}`;
        if (dateFrom) queryString += `&fromDate=${moment(date.fromDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")}`;
        if (dateTo) queryString += `&toDate=${moment(date.todate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")}`;
        const UserActivityHistoryData = new Promise((resolve) => {
            resolve(GetTokenApi(API_Path.getUserActivityHistory + queryString));
        });
        UserActivityHistoryData.then((res) => {
            if (res) {
                setUserActivityData(res.data[0]);
                setTotleRecode(res.data[1][0].total_count);
            } else {
                toast.error(res.statusText);
            }
            setBTNLoading(false);
            setLoading(false);
        });
    };

    const columns = [
        {
            name: "Created On",
            selector: (row) => row.ent_date,
            sortable: true,
            cell: (row) => <div>{moment(row.ent_date).format("DD/MM/YYYY h:mm:ss A")}</div>,
        },
        { name: "IP Address", selector: (row) => row.act_ip },
        { name: "Location", selector: (row) => row.location },
        { name: "Activity", selector: (row) => row.activity },
        { name: "Access Device", selector: (row) => row.user_agent },
    ];

    const handleSerach = () => {
        if (date.fromDate != "" && date.fromDate != undefined || date.todate != "" && date.todate != undefined) {
            GetUserActivityHistoryData(currentPage, rowsPerPage, date.fromDate, date.todate);
            setBTNLoading(true);
        }
        //  else {
        //     setBTNLoading(true);
        //     toast.warn("Select a date, from the start date to the end date.", { autoClose: 2000 });
        //     setTimeout(() => {
        //         setBTNLoading(false);
        //     }, 1000);
        // }
    };

    const handleReset = () => {
        setDate({ fromDate: "", todate: "" });
        if ((date.fromDate != "" && date.fromDate != undefined) || (date.todate != "" && date.todate != undefined)) GetUserActivityHistoryData(currentPage, rowsPerPage, "", "", searchQuery);
        setBTNLoading(false);
    };

    return (
        <React.Fragment>
            <div className={`${styles.personal_info_body}`}>
                <div className={`${styles.filter_flex} flex-wrap filter-head`}>
                    <div className={styles.title}>
                        <h6>User Activity</h6>
                    </div>
                    <div className="filter-main">
                        <ul className={`${styles.adv_filter} mb-0 pb-0`}>
                            <li className={styles.date_filter_main}>
                                <div className={styles.date_filter}>
                                    <label>From Date</label>
                                    <div className={styles.input_box}>
                                        <DatePicker
                                            selectsStart
                                            selected={date.fromDate}
                                            onChange={(e) => {
                                                setDate({ ...date, fromDate: e });
                                                setBTNLoading(false);
                                            }}
                                            startDate={date.fromDate}
                                            maxDate={date.todate ? date.todate : maxDateString}
                                            dateFormat="dd/MM/yyyy" // Updated to use `yyyy`
                                            placeholderText="DD/MM/YYYY" // Updated to use `yyyy`
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            </li>
                            <li className={styles.date_filter_main}>
                                <div className={styles.date_filter}>
                                    <label>To Date</label>
                                    <div className={styles.input_box}>
                                        <DatePicker
                                            selectsEnd
                                            selected={date.todate}
                                            onChange={(e) => {
                                                setDate({ ...date, todate: e });
                                                setBTNLoading(false);
                                            }}
                                            endDate={date.todate}
                                            startDate={date.fromDate}
                                            minDate={date.fromDate}
                                            maxDate={maxDateString}
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="DD/MM/YYYY"
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div className="form-group">
                            <div className={`${styles.personal_info_btn} text-center d-flex py-0 justify-content-end`}>
                                <button type="button" className={`${styles.button} primary_button me-3 d-flex align-items-center`} onClick={handleSerach} disabled={btnLoading}>
                                    Search
                                    {btnLoading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                </button>
                                <button type="button" className={`${styles.button} primary_button`} onClick={handleReset}>
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div className={styles.icon_search_Section}>
                        <div className="col-lg-4 col-md-4 col-sm-4 mb-2">
                            <div className={styles.section_flex}>
                                <ul>
                                    <li className={`${styles.info_section_icon} ms-0`}>
                                        <button
                                            type="button"
                                            className={styles.btn_dt}
                                            disabled={userActivityData.length === 0}
                                            onClick={() => exportTableToPDF(userActivityData, columns, "user_activity_pdf", "Activity History")}
                                        >
                                            <img src={PDFIcon} alt="" />
                                        </button>
                                    </li>
                                    <li className={styles.info_section_icon}>
                                        <button
                                            type="button"
                                            className={styles.btn_dt}
                                            disabled={userActivityData.length === 0}
                                            onClick={() => exportTableToExcel(userActivityData, "user_activity_excel", columns)}
                                        >
                                            <img src={excelIcon} alt="" />
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8 col-sm-8">
                            <div className={styles.section_searchbar}>
                                <input type="search" placeholder="Search" className="form-control" value={searchQuery} onChange={(e) => handleSearchData(e.target.value)} maxLength={50} />
                            </div>
                        </div>
                    </div>
                    <div className="data_table_body">
                        {loading ? (
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Created On</th>
                                        <th>IP Address</th>
                                        <th>Location</th>
                                        <th>Activity</th>
                                        <th>Access Device</th>
                                    </tr>
                                </thead>
                                <tbody className="d-table-caption bg-white">
                                    <tr className="d-block">
                                        <td className="d-block">
                                            <div className={styles.loader_market}>
                                                <Loader />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        ) : userActivityData.length > 0 ? (
                            <DataTableComponents
                                fetchData={GetUserActivityHistoryData}
                                columns={columns}
                                userdata={userActivityData}
                                TotalRows={totleRecode}
                                fromDate={date.fromDate}
                                toDate={date.todate}
                                paginationDefaultPage={currentPage}
                                paginationPerPage={rowsPerPage}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handleRowsPerPageChange}
                            />
                        ) : (
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Created On</th>
                                        <th>IP Address</th>
                                        <th>Location</th>
                                        <th>Activity</th>
                                        <th>Access Device</th>
                                    </tr>
                                </thead>
                                <NoDataFoundImg />
                            </Table>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
